import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./assets/css/style.css";
import "../src/common/themes/theme.css";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./components/context/LoginContext/AuthContext";
import AppRoutes from "./routes/AppRoutes";
import { RoleProvider } from "./components/admin/RoleProvider/RoleProvider";
import { StudentAuthProvider } from "./components/context/StudentLoginContext/StudentAuthContext";
import { StudentRoleProvider } from "./components/admin/RoleProvider/StudentRoleProvider";
import { Toaster } from "react-hot-toast";
import { DefaultMeta } from "./DefaultMeta";
import Analytics from "./setupAnalytics";
import { TenantAuthProvider } from "./context/TeanantAuthProvider";
import "./components/i18n";
import { Suspense } from "react";
import { NotificationProvider } from "./context/NotificationProvider";
import { SchlStudentNotificationProvider } from "./components/context/StudentNotificationContext/SchlStudentNotificationContext";
import { GoogleOAuthProvider } from "@react-oauth/google";

function App() {
  return (
    <Suspense fallback={null}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <Router>
          <TenantAuthProvider>
            <AuthProvider>
              <StudentAuthProvider>
                <RoleProvider>
                  <StudentRoleProvider>
                    <SchlStudentNotificationProvider>
                      <NotificationProvider>
                        <DefaultMeta />
                        <Analytics />
                        <AppRoutes />
                        <Toaster
                          position="bottom-right"
                          reverseOrder={false}
                          toastOptions={{
                            duration: 5000, // duration in milliseconds (default is 4000)
                          }}
                        />{" "}
                      </NotificationProvider>
                    </SchlStudentNotificationProvider>
                  </StudentRoleProvider>
                </RoleProvider>
              </StudentAuthProvider>
            </AuthProvider>
          </TenantAuthProvider>
        </Router>
      </GoogleOAuthProvider>
    </Suspense>
  );
}

export default App;
